import { TabSelectorContainerComponent } from './tab-selector-container/tab-selector-container.component';

export const COMPONENTS = [
  TabSelectorContainerComponent,
];

export * from './tab-selector-container/tab-selector-container.component';
